import {useEffect, useState} from 'react'
import { useEntityCrud } from '../../hooks/useEntityCrud'
import { toast } from 'react-toastify'

const Transfer = () => {

    const [rows,setRows] = useState([])
    const [description,setDescription] = useState('')
    const [current,setCurrent] = useState({})

    const { readData } = useEntityCrud('Info/GetTransferTypes')
    const { addData: updateStatus } = useEntityCrud('Info/ActivateTransferTypes')
    const { addData: updateDescription } = useEntityCrud('Info/TransferTypeRule')

    const getData = () => {
        readData().then(({ data }) => {
            if(data.status)
                setRows(data.result)
        })
    }

    useEffect(() => {
        getData()
    },[])

    useEffect(() => {
        if(current)
            setDescription(current.description)
    },[current])

    const changeStatus = (id,isActive) => {
        const postedData = {
            id,
            status: !isActive
        }
        updateStatus(postedData).then(({ data }) => {
            if(data.status){
                toast.success('وضعیت مورد نظر با موفقیت به روزرسانی شد')
                getData()
            }else
                data.errors.map(error => toast.error(error.message))
        })
    }

    const saveChanges = () => {
        const postedData = {
            id: current.id,
            description
        }
        updateDescription(postedData).then(({ data }) => {
            if(data.status){
                document.getElementById('close-modal-btn').click()
                toast.success('توضیحات مورد نظر با موفقیت به روزرسانی شد')
                getData()
            }else
                data.errors.map(error => toast.error(error.message))
        })
    }

    return (
        <>
            <table className="table table-hover table-bordered bg-white">
                <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>مبدا و مقصد</th>
                        <th>وضعیت</th>
                        <th>عملیات</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row,index) => <tr key={index}>
                        <td>{++index}</td>
                        <td>{`از ${row.sourceTitle} به ${row.destinationTitle}`}</td>
                        <td>{row.isActive ? 'فعال' : 'غیرفعال'}</td>
                        <td>
                            <button className="btn btn-icon mb-0 btn-primary me-2" data-bs-toggle="modal" data-bs-target="#edit" title="ویرایش" onClick={() => {setDescription('');setCurrent(row)}}><i className="fe fe-edit-2"></i></button>
                            {row.isActive ? <button onClick={e => changeStatus(row.id,row.isActive)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی"><i className="fe fe-x"></i></button> : <button onClick={e => changeStatus(row.id,row.isActive)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>}
                        </td>
                    </tr>)}
                </tbody>
            </table>
            <div className="modal fade" id="edit" tabindex="-1" aria-labelledby="editLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-6" id="editLabel">ویرایش توضیحات</h1>
                        <button type="button" id="close-modal-btn" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>توضیحات</label>
                            <textarea className="form-control" style={{minHeight: 150}} value={description} rows={5} onChange={e => setDescription(e.target.value)}></textarea>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal">لغو</button>
                        <button type="button" className="btn btn-success" onClick={saveChanges}>ذخیره اطلاعات</button>
                    </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Transfer